(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratHistoryDialogController', ContratHistoryDialogController);

    ContratHistoryDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContratHistoryDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.contrat = null;
        vm.historiques = [];
        vm.clear = clear;
        vm.isLoading = true;

        if (entity && entity.$promise && angular.isFunction(entity.$promise.then)) {
            entity.$promise.then(loadHistory, function() {
                vm.isLoading = false;
            });
        } else {
            loadHistory(entity);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadHistory(loadedEntity) {
            vm.contrat = loadedEntity || {};
            if (!vm.contrat.id) {
                vm.isLoading = false;
                return;
            }
            Contrat.getHistory({id: vm.contrat.id}, function(result) {
                vm.historiques = result;
                vm.isLoading = false;
            }, function() {
                vm.isLoading = false;
            });
        }
    }
})();
